import { useSelector, shallowEqual } from "react-redux";
import { isWhiteLabel } from "app/reducers/brandSelector";
import { getBrandDisplayName, getFallbackRedirectUrl } from "app/reducers/partnerSelector";
import { useLocation } from "react-router-dom";
import TechnicalError from "app/pages/TechnicalError/TechnicalError";
import { useEffect } from "react";
import { useAnalytics } from "app/utils/analytics/useAnalytics";

const mapStateToProps = state => ({
	strategy: state.partner.strategy,
	brandDisplayName: getBrandDisplayName(state),
	shop: state.shop,
	isWhiteLabel: isWhiteLabel(state),
	isDoubleOptin: state.partner.isDoubleOptin,
	teasingEndDate: state.partner.teasingEndDate,
	fallbackRedirectUrl: getFallbackRedirectUrl(state),
});

const TechnicalErrorContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	const location = useLocation();
	const { track } = useAnalytics();

	const errorMessage = location?.state?.errorMessage;
	const errorDetail = location?.state?.errorDetail;

	useEffect(() => {
		track("technical-error", {
			errorMessage,
			errorDetail,
		});
	}, [errorMessage, errorDetail]);

	return <TechnicalError {...props} {...stateProps} errorMessage={errorMessage} />;
};

export default TechnicalErrorContainer;
